import { __decorate } from "tslib";
import { Expose } from 'class-transformer';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
import { PatchNonPersistentCartDto } from './PatchNonPersistentCartDto';
let PatchCartDto = class PatchCartDto extends PatchNonPersistentCartDto {
};
PatchCartDto = __decorate([
    Expose({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] })
], PatchCartDto);
export { PatchCartDto };
//# sourceMappingURL=PatchCartDto.js.map